import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { ProductsListHook } from "hooks/list/useProductsList";

import { IndoorOrOutdoor } from "types/enums";

function ProductsExtraFilters({ productsListHook }: { productsListHook: ProductsListHook }) {
    const { staticFilterHook } = productsListHook;

    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Tipologia"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Indoor", value: IndoorOrOutdoor.indoor },
                        { label: "Outdoor", value: IndoorOrOutdoor.outdoor },
                    ]}
                    setValue={setValue}
                    value={form.type}
                    path={"type"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Visibile nell'area pubblica"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Visibile", value: true },
                        { label: "Non visibile", value: false },
                    ]}
                    setValue={setValue}
                    value={form.front_visible}
                    path={"front_visible"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Visibile nell'area riservata"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Visibile", value: true },
                        { label: "Non visibile", value: false },
                    ]}
                    setValue={setValue}
                    value={form.reserved_area_visible}
                    path={"reserved_area_visible"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Novità"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Si", value: true },
                        { label: "No", value: false },
                    ]}
                    setValue={setValue}
                    value={form.is_new}
                    path={"is_new"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>
        </GridRow>
    );
}

function ProductsTableFilters({ productsListHook }: { productsListHook: ProductsListHook }) {
    const { onSearchFilterChange, filterSearchHook, staticFilterHook } = productsListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearStaticFilters, clearFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<ProductsExtraFilters productsListHook={productsListHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.name}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default ProductsTableFilters;
